"use strict";

var _Fragment;
import { CarouselAssets } from '@autoguru/carousel-assets';
import { ContainedLayout } from '@autoguru/layout';
import { KiaOraIntroDesktop } from '~/src/components/KiaOraIntro/KiaOraIntroDesktop';
import { LearnMore } from '~/src/components/LearnMore/LearnMore';
import { makeLogosList } from '~/src/components/MakeLogosCarousel/makeLogos';
import { ManageAllFleetVehicles } from '~/src/components/ManageAllFleetVehicles/ManageAllFleetVehicles';
import { OnePortalUSP } from '~/src/components/OnePortalUSP/OnePortalUSP';
import { ServiceAllVehicles } from '~/src/components/ServiceAllVehicles/ServiceAllVehicles';
import { ServiceProvidersFeedback } from '~/src/components/ServiceProvidersFeedback/ServiceProvidersFeedback';
import { jsx as _jsx, Fragment as _Fragment2, jsxs as _jsxs } from "react/jsx-runtime";
export const LandingDesktop = () => _Fragment || (_Fragment = /*#__PURE__*/_jsxs(_Fragment2, {
  children: [/*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingBottom: "1",
    children: /*#__PURE__*/_jsx(KiaOraIntroDesktop, {})
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingX: "7",
    paddingTop: "7",
    paddingBottom: "1",
    children: /*#__PURE__*/_jsx(ServiceAllVehicles, {})
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingX: "8",
    paddingTop: "8",
    paddingBottom: "7",
    children: /*#__PURE__*/_jsx(CarouselAssets, {
      assetList: makeLogosList
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingBottom: "1",
    children: /*#__PURE__*/_jsx(ManageAllFleetVehicles, {
      isDesktop: true
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingLeft: "8",
    paddingY: "8",
    paddingBottom: "1",
    children: /*#__PURE__*/_jsx(OnePortalUSP, {
      isDesktop: true,
      size: "8"
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingY: "8",
    paddingBottom: "1",
    children: /*#__PURE__*/_jsx(ServiceProvidersFeedback, {
      isDesktop: true,
      size: "8"
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    dropMobileXMargins: true,
    width: "bleed",
    paddingX: "9",
    paddingY: "8",
    children: /*#__PURE__*/_jsx(ContainedLayout, {
      dropMargins: true,
      width: "medium",
      paddingX: "9",
      children: /*#__PURE__*/_jsx(LearnMore, {
        isDesktop: true,
        size: "8"
      })
    })
  })]
}));
export default LandingDesktop;